<template>
  <app-sidenav v-if="hasLoggedIn" />
  <main :class="{'logged-in' : hasLoggedIn}">
    <router-view/>
  </main>
  
</template>

<script>
import { mapState } from "pinia";
import AppSidenav from "./components/ui/AppSidenav.vue";
import { useMainStore } from "./store";

export default {
  computed:{
    ...mapState(useMainStore , ['hasLoggedIn'])
  },
  components:{
    AppSidenav
  },
  async created(){
    await useMainStore().getPlans()
    await useMainStore().getWebpayMallIntegrationDefaults()
  }
}
</script>